import { useState } from 'react';

// Form tạo công việc từ danh sách KH đã chọn (mã KH). Dùng qua openModal().
export default function CreateTaskFromCustomers({ picked, groups, hideGroup, onCancel, onSubmit }) {
  const [title, setTitle] = useState('');
  const [detail, setDetail] = useState('');
  const [group, setGroup] = useState('all');
  const dlDefault = new Date(Date.now() + 3 * 864e5).toISOString().slice(0, 10);
  const [deadline, setDeadline] = useState(dlDefault);
  const [useStatuses, setUseStatuses] = useState(false);
  const [statuses, setStatuses] = useState([]);
  const [statusInput, setStatusInput] = useState('');
  const [busy, setBusy] = useState(false);

  function addStatus() {
    const v = statusInput.trim();
    if (!v) return;
    if (!statuses.includes(v)) setStatuses([...statuses, v]);
    setStatusInput('');
  }

  async function submit() {
    if (!title.trim()) return;
    setBusy(true);
    try {
      await onSubmit({ title: title.trim(), detail: detail.trim(), group, deadline, statuses: useStatuses ? statuses : [] });
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <span className="close" onClick={onCancel}>
        ×
      </span>
      <h3>Tạo công việc mới</h3>
      <div className="field">
        <label>Tiêu đề công việc</label>
        <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="vd: Chăm sóc nhóm KH doanh thu cao" />
      </div>
      <div className="field">
        <label>Yêu cầu chi tiết</label>
        <textarea rows={3} value={detail} onChange={(e) => setDetail(e.target.value)} placeholder="Mô tả công việc cần làm..." />
      </div>
      <div className="two-col">
        {!hideGroup && (
          <div className="field">
            <label>Giao cho nhóm kinh doanh</label>
            <select value={group} onChange={(e) => setGroup(e.target.value)}>
              <option value="all">★ Tất cả các nhóm (tự chia theo từng nhân viên)</option>
              {groups.map((g) => (
                <option key={g._id} value={g._id}>
                  {g.name}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="field">
          <label>Hạn nhân viên hoàn thành</label>
          <input type="date" value={deadline} onChange={(e) => setDeadline(e.target.value)} onClick={(e) => e.currentTarget.showPicker?.()} />
        </div>
      </div>
      <div className="demo-hint">
        Hệ thống tự chia khách hàng theo từng nhân viên (theo sale của KH). {hideGroup ? 'Chỉ áp dụng cho nhóm của bạn.' : ''} Trưởng phòng có thêm 1 ngày sau hạn này để kiểm tra & duyệt.
      </div>

      <div className="field">
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
          <input type="checkbox" style={{ width: 'auto' }} checked={useStatuses} onChange={(e) => setUseStatuses(e.target.checked)} />
          Tạo trạng thái kết quả để nhân viên chọn
        </label>
      </div>
      {useStatuses && (
        <div className="card" style={{ background: 'var(--panel2)' }}>
          <div className="row" style={{ gap: 8 }}>
            <input
              style={{ flex: 1 }}
              value={statusInput}
              onChange={(e) => setStatusInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addStatus())}
              placeholder="Nhập 1 trạng thái rồi bấm Thêm…"
            />
            <button className="btn sm" onClick={addStatus}>
              + Thêm
            </button>
          </div>
          <div style={{ marginTop: 10 }}>
            {statuses.length ? (
              statuses.map((s) => (
                <span className="tag" key={s} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                  {s}
                  <span style={{ cursor: 'pointer', color: 'var(--danger)', fontWeight: 700 }} onClick={() => setStatuses(statuses.filter((x) => x !== s))}>
                    ×
                  </span>
                </span>
              ))
            ) : (
              <span className="small muted">Chưa có trạng thái nào.</span>
            )}
          </div>
        </div>
      )}

      <div className="field">
        <label>Khách hàng đã chọn ({picked.length})</label>
        <div style={{ maxHeight: 120, overflowY: 'auto' }}>
          {picked.map((c) => (
            <span className="tag" key={c.code}>
              {c.code} · {c.name}
            </span>
          ))}
        </div>
      </div>

      <div className="row" style={{ marginTop: 16 }}>
        <div className="spacer" />
        <button className="btn ghost" onClick={onCancel}>
          Hủy
        </button>
        <button className="btn" onClick={submit} disabled={busy || !title.trim()}>
          {busy ? 'Đang tạo…' : 'Tạo & giao việc'}
        </button>
      </div>
    </>
  );
}
